// extracted by mini-css-extract-plugin
export default {"tab":"index_tab_-jKc4"};